/**
 * lib-blueprint
 *
 * Adapptio library for processing blueprints.
 *
 * @package lib-blueprint
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ISchemaValue, ISchemaValueOpts, SchemaValue } from "./SchemaValue";
import {
	ISchemaConstPassword,
	ISchemaConstPasswordOpts,
	SchemaConstPassword
} from "../const/SchemaConstPassword";

export interface ISchemaValuePasswordOpts
	extends ISchemaValueOpts<ISchemaConstPassword>,
		ISchemaConstPasswordOpts {}

/**
 * Schema: Password value
 *
 * @param opts Schema options
 */
export function SchemaValuePassword(opts: ISchemaValuePasswordOpts): ISchemaValue<ISchemaConstPassword> {

	return SchemaValue(SchemaConstPassword(opts), opts);

}
